import React from "react";
import { Icon } from "@iconify/react";
import AnimatedCard from "./AnimatedCard";
import Grid from "../assets/images/grid_lines.png"
import getYouTubeEmbedUrl from "../utils/videoUrlExtractor";



const CardSection = () => {
  // Sample card data with videos
  const cards = [
    {
      id: 1,
      title: "Personalized and Tailored Learning for Every Student",
      description:
        "Every lesson adapts to your unique strengths, interests, and challenges - creating a customized learning journey that bridges gaps and maximizes your potential.",
      icon: "ph:brain-duotone",
      iconColor: "text-primary-700",
      bgColor: "bg-primary-100",
      direction: "left",
      video: "https://youtu.be/yXgZHEdoHrE",
    },
    {
      id: 2,
      title: "Your Learning Companion, Anytime, Anywhere",
      description:
        "Experience the power of our 24/7 Standby Intelligent Tutor. Whether it's solving homework challenges at midnight or preparing for exams early in the morning, the Bildup AI tutor ensures that learning never takes a backseat.",
      icon: "ph:chart-line-up-duotone",
      iconColor: "text-amber-500",
      bgColor: "bg-amber-100",
      direction: "right",
      video: "https://youtu.be/49aZFomGwmU",
    },
    {
      id: 3,
      title: "Personalized Home Lessons, Designed for You",
      description:
        "Bildup AI creates customized home study lessons based on the Nigerian and British curricula, guides you step-by-step, and ensures you master every topic.",
      icon: "ph:users-three-duotone",
      iconColor: "text-teal-500",
      bgColor: "bg-teal-100",
      direction: "left",
      video: "https://youtu.be/Os6ldsKc2R0",
    },
    {
      id: 4,
      title: "Unified Support for Parents and Teachers",
      description:
        "Empowering teachers and parents with the tools to ensure every learner thrives. Real-time progress tracking and feedback that drive continuous improvement.",
      iconColor: "text-indigo-500",
      bgColor: "bg-indigo-100",
      direction: "right",
      video: "https://youtu.be/XIyxdVKMf6s",
    },
  ];

  return (
    <section className="md:py-16 py-0 px-4 ">

      <div className="max-w-screen-xl mx-auto">
        {/* <div className="text-center mb-16">
          <AnimatedCard direction="fadeIn" duration={0.8} once={true}>
            <h2 className="text-3xl md:text-4xl font-bold text-primary-700 mb-4">
              Features That Set Us Apart
            </h2>
            <p className="text-lg text-gray-600 max-w-2xl mx-auto">
              Discover why thousands of students choose Bildup for their learning
              journey
            </p>
          </AnimatedCard>
        </div> */}

        <div className="flex flex-col gap-16">
          {cards.map((card, index) => {
            const isEven = index % 2 !== 0;

            return (
              <AnimatedCard
                key={card.id}
                direction={isEven ? "right" : "left"}
                delay={0.1}
                once={false}
                resetOnExit={true}
              >
                <div className={`flex flex-col ${isEven ? 'md:flex-row-reverse' : 'md:flex-row'} gap-8 items-center light-main  rounded-2xl md:px-16 relative md:p-8 p-4 overflow-hidden`}>
                  <div className="absolute inset-0 opacity-100 bottom-0 h-full w-full" style={{
                    backgroundImage: `url(${Grid})`,
                    backgroundSize: 'contain',
                    transform: 'skewY(-10deg) scale(1.2)',
                    transformOrigin: 'bottom right'
                  }}></div>
                  <div className="w-full md:w-1/2 md:h-[300px]  relative z-10">
                    <div className="p-6 rounded-lg backdrop-blur-sm h-full ">
                      {/* <div className={`${card.bgColor} p-3 rounded-full w-fit mb-4`}>
                        <Icon icon={card.icon} className={`${card.iconColor} w-8 h-8`} />
                      </div> */}
                      <h3 className="md:text-[40px] text-[20px] text-center md:text-start  tracking-tight text-primary-700 mb-3">
                        {card.title}
                      </h3>
                      <p className="text-gray-700 text-[16px] text-center md:text-start leading-relaxed">
                        {card.description}
                      </p>
                      {/* <div className="mt-6 flex items-center text-primary-600 group">
                        <span className="font-medium mr-2">Learn more</span>
                        <Icon 
                          icon="solar:arrow-right-broken" 
                          className="w-5 h-5 transition-transform group-hover:translate-x-1" 
                        />
                      </div> */}
                    </div>
                  </div>

                  <div className={`w-full md:w-1/2 overflow-hidden rounded-lg    shadow-lg relative z-10`}>
                    {card.video && card.video.includes('youtu') ? (
                      // YouTube embed with proper styling
                      <div className="relative pb-[56.25%] h-0 overflow-hidden">
                        <iframe
                          src={`${getYouTubeEmbedUrl(card.video)}?autoplay=0&rel=0&modestbranding=1&mute=1`}
                          className="absolute top-0 left-0 w-full h-full"
                          title={card.title}
                          frameBorder="0"
                          loading="lazy"
                          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                          allowFullScreen
                        ></iframe>
                      </div>
                    ) : (
                      // Regular video for direct video URLs
                      <video
                        src={card.video}
                        className="w-full h-[300px] object-cover transform hover:scale-105 transition-transform duration-500"
                        autoPlay
                        muted
                        loop
                        playsInline
                      />
                    )}
                  </div>
                </div>
              </AnimatedCard>
            );
          })}
        </div>

        <div className="mt-16">
          <AnimatedCard
            direction="bottom"
            delay={0.4}
            className="text-center"
            once={false}
            resetOnExit={true}
          >
            <button className="mt-2 md:mt-0 py-2 px-6 bg-primary-700 text-white rounded-full hover:bg-primary-800 flex items-center group transition-all ease-in-out duration-500 mx-auto">
              <span>Explore all features</span>
              <div className="ml-2 text-white">
                <Icon
                  icon="solar:arrow-right-broken"
                  className="w-5 h-5 transition-all ease-in-out duration-500 group-hover:-rotate-45 group-hover:translate-x-1"
                />
              </div>
            </button>
          </AnimatedCard>
        </div>
      </div>
    </section>
  );
};

export default CardSection;


